import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { ImagesProvider } from "@/context/ImagesContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import Grow from "@/components/Grow";
import Land from "@/components/Land";
import Timeline from "@/components/Timeline";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminImages from "@/pages/AdminImages";

const Landing = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-cream text-espresso" data-testid="masthare-app">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <Grow />
        <Land />
        <Timeline />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ImagesProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/manage-images" element={<AdminImages />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </ImagesProvider>
  );
}

export default App;
